import TableTrio from './TableTrio';

import AssociatedItems from './AssociatedItems/index';
import AssociatedItemsVersions from './AssociatedItemsVersion/index';
import ReferenceAttachments from './ReferenceAttachments/index';

export { AssociatedItems, AssociatedItemsVersions, ReferenceAttachments };

export default TableTrio;
